<nav class="navbar navbar-expand-lg navbar-dark bg-dark" style="position:fixed;top:0;width:100%;z-index: 1000;">
  <img src="../../../assets/images/Deloitte Logo.svg" width="70" height="70" class="navbar-logo"/>
  <span class="navbar-separator">|</span>
  <a class="navbar-brand">GatePass Digitalization</a>

  <div class="collapse navbar-collapse show" id="navbarSupportedContent" *ngIf="this.isDenied !== 'true'">
    <ul class="navbar-nav mr-auto flex-grow-1">
     <!-- <li  dropdown class="nav-item dropdown-vendor"  routerLinkActive="active" *ngIf="showMyRequestsTab()">
        <a  id="basic-link" dropdownToggle  class="nav-link"
        aria-controls="basic-link-dropdown" 
          aria-haspopup="true" aria-expanded="false" routerLink="/Outward">My Requests
          <span id="vendorDropdownIcon" class="" style="padding-left:5px; font-size:8px;"></span>
        </a>
      </li>-->
      
      <!-- <li  dropdown class="nav-item dropdown-vendor"  routerLinkActive="active" *ngIf="showOutwardTab()">
        <a  id="basic-link" dropdownToggle  class="nav-link"
        aria-controls="basic-link-dropdown" 
          aria-haspopup="true" aria-expanded="false" >Outward Requests
         
        </a>  -->
            <!-- <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu menu-vendor"
          aria-labelledby="basic-link">
              <li>
                <a class="dropdown-item vendor-item" routerLink="/OutwardL1Approver" *ngIf="this.isL1 === 'true'">L1 Approver</a>
              </li>
              <li >
                <a class="dropdown-item vendor-item" routerLink="/OutwardL2Approver" *ngIf="this.isL2 === 'true'">L2 Approver</a>
              </li>
              <li>
                <a class="dropdown-item vendor-item" routerLink="/OutwardSupervisor" *ngIf="this.roleId == this.roleAdmin || this.roleId == this.roleSuperAdmin || this.roleId == this.roleSecuritySupervisor">Supervisor</a>
              </li>
            </ul> -->
      <!-- </li> -->

     <!-- <li  dropdown class="nav-item dropdown-vendor"  routerLinkActive="active" *ngIf="(this.roleId != this.roleUser)">
        <a  id="basic-link" dropdownToggle  class="nav-link"
        aria-controls="basic-link-dropdown" 
          aria-haspopup="true" aria-expanded="false" routerLink="/Inward">Inward Registrations
          <span id="vendorDropdownIcon" class="" style="padding-left:5px; font-size:8px;"></span>
        </a> 
      </li>-->
       
     <!-- <li  dropdown class="nav-item dropdown-vendor"  routerLinkActive="active" *ngIf="(this.roleId==this.roleAdmin || this.roleId == this.roleSuperAdmin)">
        <a  id="basic-link" dropdownToggle  class="nav-link"
        aria-controls="basic-link-dropdown" 
          aria-haspopup="true" aria-expanded="false">Configuration
          <span id="vendorDropdownIcon" class="icon-ic_dropdown" style="padding-left:5px; font-size:8px;"></span>
        </a> 
            <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu menu-vendor"
          aria-labelledby="basic-link">
              <li>
                <a class="dropdown-item vendor-item" routerLink="/Office">Office</a>
              </li>
              <li >
                <a class="dropdown-item vendor-item" routerLink="/Users">Users</a>
              </li>
             
              <li>
                <a class="dropdown-item vendor-item" routerLink="/Cities">City</a>
              </li>
            </ul>
      </li>-->

      <!--<li  dropdown class="nav-item dropdown-vendor"  routerLinkActive="active" *ngIf="(this.roleId==this.roleAdmin || this.roleId == this.roleSuperAdmin)">
        <a  id="basic-link" dropdownToggle  class="nav-link"
        aria-controls="basic-link-dropdown"  routerLink="/AuditConfiguration"
          aria-haspopup="true" aria-expanded="false">Audit Trail
          
        </a> 
           
      </li>-->
    </ul> 

    <ul class="nav navbar-nav image ml-auto">
      <li class="nav-item dropdown">
          <a class="nav-link" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span *ngIf="imageToShow" class="navbar-profile-avatar">
              <img 
                [src]="imageToShow"
                alt="{{ userInitials }}" />
            </span>
            <span *ngIf="!imageToShow" class="navbar-profile-initials">{{userInitials}}</span> 
            <span class="icon-ic_dropdown navbar-profile-caret"></span>

          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <div class="dropdown-item">
                  <span class="username">{{userInitials}}</span>
                  <ul style="margin-top: -10px;margin-left: 10px;line-height: 23px;font-size: 13px;">                       
                      <li>
                        <span class="user-fullname">{{userName}}</span>                             
                      </li>
                      <li><span class="user-desig">{{userRole}}</span></li>
                  </ul>
              </div>
                  <div class="dropdownitem" (click)="downloadPrivacy()"><span>Privacy Policy</span></div>
                  <hr>
            <div class="dropdownitem" (click) = "logOut()"><span>Log out</span></div>
            <hr>
            <div class="dropdownitem" (click)="cookieRedirect()">
              <span>
                <img src="../../../assets/images/cookie.svg" alt="icon-cookie">
                Cookie Notice
              </span>
            </div>
            <hr>
            <div class="dropdownitem">
              <a id="cookie-settings"
                class="optanon-toggle-display"
                (click)="dropdown.hide()"
              >
                  <img src="../../../assets/images/cookie.svg" alt="icon-cookie">
                  Cookie Settings
              </a>
            </div>
                  <hr>
          </div>
        </li> 
    </ul>

  </div>
</nav>
